const templates = [
  {
    title: 'Waiter/Waitress',
  },
  {
    title: 'Cook',
  },
  {
    title: 'Barista',
  },
  {
    title: 'Cashier',
  },
  {
    title: 'Retail Sales Representative',
  },
  {
    title: 'Driver',
  },
  {
    title: 'Security Guard',
  },
  {
    title: 'Customer Service Representative',
  },
  {
    title: 'Store Manager',
  },
  {
    title: 'Bartender',
  },
  {
    title: 'Dishwasher',
  },
  {
    title: 'Deliver',
  },
  {
    title: 'Cleaner/Janitor',
  },
  {
    title: 'Valet',
  },
  {
    title: 'Auto Technician',
  },
  {
    title: 'Construction Worker',
  },
  {
    title: 'Receptionist',
  },
  {
    title: 'Catering Staff',
  },
  {
    title: 'Lifeguard',
  },
  {
    title: 'Grocery Store Stocker',
  },
  {
    title: 'Tutor',
  },
  {
    title: 'Babysitter',
  },
  {
    title: 'Ice Cream Scooper',
  },
  {
    title: 'Movie Usher',
  },
];

export default templates;
